module.exports = __webpack_public_path__ + "static/media/Trumbeak_gaussian2.95705ade.png";